module.exports = __webpack_public_path__ + "static/integration/custom/web.928ad8a05e88c262c86446eecfa5abb7.css";